<template>
  <div id="app">
    <!-- Login -->
    <div v-if="!logueado && reservaEncuesta==0"><home/></div>

    <!-- Inicio -->
    <div v-else>
      <div><AppHeader/></div>

      <div class="pb-4">

        <div v-if="reservaEncuesta > 0">
          <encuesta/>
        </div>

        <div v-else>
          <AppMenu/>
        </div>

      </div>
      <!-- <div class="cuerpo">
        <router-view/>
      </div> -->
      <div><AppFooter/></div>
    </div>

    <!-- Componentes -->
    <loading ref="loading"></loading>
    <alerta ref="alerta"></alerta>
    <modal ref="modal"></modal>

    <!-- ModalC -->
    <modalC></modalC>

    <!---------------------------- modales  -------------------------->
    <!-- login -->
    <!-- <loginM/>     -->
    <passwordM/>

    <lopdM/>
    <!-- registro -->
    <!-- <registroM/> -->
    <!-- confirmacion Codigo -->
    <!-- <confCodigo/> -->

    <!-- hotel modales -->
    <hotelPreciosM/>
    <hotelImagenesM/>
    <hotelDispoM/>
    <precios/>

  </div>
</template>

<script>

import loading from '@/components/loading.vue'
import alerta from '@/components/alerta.vue'
import modal from '@/components/modal.vue'
import modalC from '@/components/ModalC.vue'

import AppHeader from '@/components/AppHeader.vue'
import AppMenu from '@/components/AppMenu.vue'
import home from '@/components/home.vue'
import AppFooter from '@/components/AppFooter.vue'
import encuesta from '@/components/encuesta.vue'

// login, registro
// import loginM from '@/components/LoginM.vue'
import passwordM from '@/components/passwordM.vue'
// import registroM from '@/components/RegistroM.vue'
// import confCodigo from '@/components/confCodigo.vue'
import lopdM from '@/components/lopdM.vue'

// modales
import hotelPreciosM from '@/components/hotel-preciosM.vue'
import hotelImagenesM from '@/components/hotel-imagenesM.vue'
import hotelDispoM from '@/components/hotel-dispoM.vue'
import precios from '@/components/precios.vue'

//aceptar cookies
//import CookieLaw from 'vue-cookie-law'

export default {
  name: 'App',
  components: {
    loading, alerta,
    modal,
    home,
    AppHeader,
    AppMenu,
    AppFooter,
    encuesta,

    modalC,
    //modales
    //loginM, registroM,
    passwordM,
    //confCodigo,
    lopdM,
    hotelPreciosM,
    hotelImagenesM,
    hotelDispoM,
    precios,

  },

  data() {
    return {
      title: 'Fondos Sociales -- Telefonica',
      // datos: false,
    }
  },

  computed: {
    logueado() {
        return this.$store.state.auth.logueado;
    },

    //reserva para encuestas
    reservaEncuesta() {
      if (this.$route.name!='encuesta') return 0;

      let r=this.$route.query.r.split('@')[1];
      return r;
    }

  },

  async created() {
    document.title=this.title;
    //sessionStorage.clear;
    //console.log("* app.created",sessionStorage);

  },

  async mounted() {

    console.log('** app.mounted',this.$route)

    //almacenamo en comps - store
    this.$store.state.comps.loading=this.$refs.loading;
    this.$store.state.comps.alerta=this.$refs.alerta;
    this.$store.state.comps.modal=this.$refs.modal;

    //$root
    this.$root.$msgBox=this.msgBox;
    this.$root.$msgConf=this.msgConf;
    //this.$root.$toast=this.toast;
    //modales
    this.$root.$hotelPrecios=this.hotelPrecios;


    // compruebo si estamos logueados
    await this.$store.dispatch("isLogin");
    //cargamos datos iniciales
    await this.$store.dispatch("datos_iniciales");

    // acceso directo desde telefonica
    //
    if (this.$route.name=='acc') {
      //this.$router.push({path: '/acc', query : { tt: "0501@031625"}});
      let r=this.$route.query.tt.split('@');
      let args={user: r[1], token: '', pass: r[0]};
      //alert('aaaaccccc -> ' + r + ' -> ' + args );
      let x=await this.$store.dispatch('exec', {api:'login', arg:args});
      this.$store.commit('login_back',x);
      this.$router.push('/');
    }


    ///////////////////////////////////////////////////////////////////////////
    // restablecer contraseña
    //
    if (this.$route.name=='res') {

      let m1="Debes de contactar con nosotros en el Teléfono <b>900 35 10 10</b>.";
      let m2="Para cualquier duda o consulta puedes contactar con nosotros en el Teléfono <b>900 35 10 10</b>.";

      let dd=this.$route.query.d;
      let d0=atob(dd);
      let d=d0.split('_')[0].split('a')[1];   //alert(d0 + " - " + d);

      let args={fnt: 'get', user: d};
      let x=await this.$store.dispatch('exec', {api:'restablecer', arg:args});

      if (x.error) {
            let m=x.datos;
            if (m=='usu')  m="Datos de Usuario incorrectos. Intentelo de nuevo.<br><br>" + m2; else
            if (m=='tfn')  m="No disponemos de su correo electrónico para iniciar el procedimiento para restablecer su contraseña para acceder a la web.<br><br>" + m1; else
            if (m=='pas1') m="Su contraseña no cumple los criterios de seguridad: entre 6 y 15 caracteres, al menos una letra y ún número.<br>"; else
            if (m=='pas2') m="Su contraseña no cumple los criterios de seguridad: entre 6 y 15 caracteres, al menos una letra y ún número.<br>"; else
            if (m=='pas3') m="Su contraseña no cumple los criterios de seguridad: No puede ser la misma, o estar contenida, de las tres últimas utilizadas.<br>"; else
            if (m=='cad')  m="Su contraseña ha caducado o no ha sido inicializada esta temporada.<br>Deberá pulsar Restablecer Contraseña y seguir el procedimiento que se le indica.<br>"; else
            if (m=='ema')  m="Se ha procedido al envio de un email a su direccion de correo con un enlace para restablecer/activar su cuenta de acceso a la web. Siga las indicaciones del mismo.<br><br>" + m2; else
            if (m=='fhp')  m="Procedimiento de Restablecer Contraseña ha caducado, deberá solicitarlo de nuevo.<br><br>" + m2; else
            m="Error - En estos momentos imposible procedimiento.<br><br><b>" + m +"</b><br><br>"+m2;

            //m="Su contraseña ha caducado o no ha sido inicializada esa temporada.<br>Deberá pulsar Restablecer Contraseña y seguir el procedimiento que se le indica.<br>";

            this.modal({tit:"Login / Acceso", msg: m, time:0});

            this.$store.commit('login_off');
            this.$router.push('/');

      } else {
        //modal
        this.$store.state.auth.user=x.datos;

        this.$bvModal.show("modal_password");

      }
    }

  },

  methods: {

    modal(component) {
      this.$bvModal.show(component);
    },

    async hotelPrecios(hotel=null) {
      if (hotel==null) hotel=this.$store.state.hoteles.hotel;
      await this.$store.dispatch('hotel_precios',hotel);
      this.$bvModal.show("modal_hotelPrecios");
    },


    //////////////////////////////////////////////////////////////////////////////////
    //modales Informacion y Confirmacion
    async msgConf(txt,tit="Atención") {
        let msg=this.htmlToVNode(txt);
        const value = await this.$bvModal.msgBoxConfirm(msg, {
            headerClass: "p-1 bg-primary text-light text-weight-bold",
            title: tit,
            size: "md", buttonSize: "sm",
            okVariant: "outline-success", okTitle: "ACEPTAR",
            cancelVariant: "danger text-light", cancelTitle: "CANCELAR",
            footerClass: "p-2 text-light",
            hideHeaderClose: true,
            noCloseOnBackdrop: true,
            noCloseOnEsc: true,
            centered: true
        });
        return value;
    },

    async msgBox(txt,tit="INFORMACIÓN") {
        let msg=this.htmlToVNode(txt);
        const value = await this.$bvModal.msgBoxOk(msg, {
            title: tit,
            size: "md", buttonSize: "sm",
            okVariant: "success",
            headerClass: "p-2 border-bottom-0",
            footerClass: "p-2 border-top-0",
            centered: true
        });
        return value;
    },

    htmlToVNode(html) {
        return [ this.$createElement('div', { domProps: { innerHTML: html } }) ];
    },

    /* toast(txt,tit="INFORMACIÓN") {
      let msg=this.htmlToVNode(txt);


      this.$bvToast.toast([msg], {
          title: [tit],
          solid: true,
          static: true,
          variant: 'danger'
      })
    }, */

  },

}
</script>

<style>

  @import './assets/css/main.css';

  .app {
    font-family: Verdana, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    /* max-width: 1000px; */
    margin: auto;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
  }
  .head {
    background-color: rgba(0, 71, 85, 0.1);
  }
  .cuerpo {
    margin-top: 0px;
  }
  /**/
  .menu-opcion
  {
  padding: 10px 0 10px 0;
  display: inline-block;
  }
  .menu-opcion ul li {
    list-style: none;
    padding: 0.5rem 0;
  }
</style>
